import { BaseApi } from './base.api.js';

export class BigdesImplementationProcessEvaluationApi extends BaseApi {
    constructor(client) {
        super(client, '/bigdes-implementation-process-evaluations');
    }
}
